export const ATTRIBUTE_TYPES_TO_REMOVE = ['existence_boolean'];
